import script from "./DetailsBanner.vue?vue&type=script&setup=true&lang=ts"
export * from "./DetailsBanner.vue?vue&type=script&setup=true&lang=ts"

import "./DetailsBanner.vue?vue&type=style&index=0&id=614f546c&lang=scss"

const __exports__ = script;

export default __exports__